// Prerendering is OFF by deliberate decision, not by oversight.
//
// 2026-09-10: hold it off for a few weeks after the DCMI 2026 VoR release, then
// revisit. SSR already gives crawlers complete HTML — title, byline, abstract and
// the Highwire/JSON-LD tags are all in the server response — so indexing does not
// depend on this. Turning it on is a build-time and latency optimisation, and it
// would freeze 704 article pages at build time, which is the wrong trade while the
// corpus is still being corrected.
//
// When re-enabling: it needs an entries() for the dynamic routes, and the routes
// that read the request (search, /oai, linkset) must stay dynamic.
export const prerender = false;
